import { ChangeDetectionStrategy, Component, inject, type OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';

/**
 * Aviso legal, condiciones de uso, condiciones comerciales, política de
 * privacidad y cookies (10/09). Página pública, sin sesión, en inglés: es el
 * texto legal de la clienta y se publica tal cual. El login y los formularios
 * de alta enlazan aquí en una pestaña nueva.
 */
@Component({
	selector: 'app-legal-notice',
	standalone: true,
	imports: [RouterLink],
	templateUrl: './legal-notice.component.html',
	styleUrl: './legal-notice.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegalNoticeComponent implements OnInit {
	private readonly title = inject(Title);

	ngOnInit(): void {
		this.title.setTitle('Legal Notice, Terms & Privacy · Kairos Merit');
	}
}
